import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
  BUTTON_SIZE,
  BUTTON_STYLE,
  BUTTON_POSITION,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'button_style',
    label: 'Button Style',
    type: types.ENUM,
    options: BUTTON_STYLE,
  },
  {
    key: 'default_style',
    label: 'Default Style',
    type: types.OBJECT,
    children: [
      {
        key: 'theme_type',
        label: 'Theme Type',
        type: types.ENUM,
        options: COMPONENT_COLOR_THEMES,
      }
    ]
  },
  {
    key: 'customized_style',
    label: 'Customized Style',
    type: types.OBJECT,
    children: [
      {
        key: 'background_color',
        label: 'Background Color',
        type: types.COLOR_PICKER,
      },
      {
        key: 'font_color',
        label: 'Font Color',
        type: types.COLOR_PICKER,
      },
    ]
  },
  {
    key: 'cta',
    label: 'CTA',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT_WITH_ICON,
        children: [
          { key: 'text', label: 'Text' },
          { key: 'icon', label: 'Icon' },
          { key: 'icon_size', label: 'IconSize' },
          { key: 'placement', label: 'Placement' },
        ],
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT,
      },
      {
        key: 'video_url',
        label: 'Video Url',
        type: types.TEXT,
      },
      {
        key: 'youtube_link',
        label: 'YouTube Video Link (Empty video url field to use YouTube link)',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'size',
    label: 'Button Size',
    type: types.ENUM,
    options: BUTTON_SIZE,
  },
  {
    key: 'size_cust',
    label: 'Button Size Customization',
    type: types.OBJECT,
    children: [
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT,
      },
      {
        key: 'height',
        label: 'Height',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'position',
    label: 'Button Position',
    type: types.ENUM,
    options: BUTTON_POSITION,
  },
];

const defaultProps = {
  button_style: 'DEFAULT',
  default_style: {
    'theme_type': 'DARK'
  },
  customized_style: {
    background_color: 'black',
    font_color: 'white'
  },
  cta: {
    label: {
      text: 'Download press kit',
      icon: 'ff-icon-check',
      placement: 'AFTER',
    },
    url: '/',
  },
  size: 'LARGE',
  position: 'CENTER',
};

export default {
  title: 'Bold Button',
  id: 'BoldButton',
  widgetImage: '/widgetImages/Button.png',
  basic: true,
  propsSchema,
  defaultProps,
};
